import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAccount } from "wagmi";
import styles from "./Sidebar.module.sass";
// import { Link, NavLink } from "react-router-dom";
import { NavLink } from "react-router-dom";
import cn from "classnames";
import Icon from "../Icon";
// import Theme from "../Theme";
import Dropdown from "./Dropdown";
import Help from "./Help";
import Image from "../Image";
import useMediaQuery from "../../customHooks/useMediaQuery";
import { POWER_USERS, MAIN_COLOR_A, CASPER_SWITCH } from "../../utils/config";
import { _isNotEmptyNftId } from "../../utils";
import { CiVault } from "react-icons/ci";
import { MdOutlineWaterDrop } from "react-icons/md";

const navigationFull = [
    {
        title: "Home",
        icon: "home",
        url: "/",
    },
    {
        title: "Overview",
        slug: "income",
        icon: "bar-chart",
        url: "/details",
    },
    {
        title: "Activity",
        slug: "income",
        icon: "activity",
        dropdown: [
            {
                title: "Overview Details",
                url: "/details",
            },
            {
                title: "Liquidations",
                url: "/liquidations",
            },
            {
                title: "Statements",
                url: "/statements",
            },
            {
                title: "Contributors",
                url: "/explore-contributors",
            },
        ],
    },
    {
        title: "Dashboards",
        slug: "products",
        icon: "diamond",
        add: true,
        dropdown: [
            {
                title: "Details Overview",
                url: "/products/dashboard",
            },
            {
                title: "Drafts",
                url: "/products/drafts",
                counter: "2",
                colorCounter: "#FFBC99",
            },
            {
                title: "Released",
                url: "/products/released",
            },
            {
                title: "Comments",
                url: "/products/comments",
            },
            {
                title: "Scheduled",
                url: "/products/scheduled",
                counter: "8",
                colorCounter: MAIN_COLOR_A,
            },
        ],
    },
    {
        title: "Analytics",
        slug: "customers",
        icon: "pie-chart",
        dropdown: [
            {
                title: "Overview",
                url: "/customers/overview",
            },
            {
                title: "List View",
                url: "/customers/customer-list",
            },
        ],
    },
    {
        title: "LiquidNFTs",
        icon: "promotion",
        url: "/promote",
    },
    ...(CASPER_SWITCH ? [{
        title: "Liquid Staking",
        reactIcon: <MdOutlineWaterDrop size={25}/>,
        url: "/liquid-staking",
    }] : []),
];

const navigationLite = [
    {
        title: "Home",
        icon: "home",
        url: "/",
    },
    /*{
        title: "Archive",
        slug: "archive",
        icon: "schedule",
        url: "/archive",
    },*/
    {
        title: "Vaults",
        slug: "vaults",
        reactIcon: <CiVault size={25} style={{ strokeWidth: .8 }} />,
        url: "/RWAvaults",
    },
    {
        title: "Farming",
        slug: "farming",
        icon: "store",
        url: "/farming",
    },
    /*{
        title: "Points",
        slug: "points",
        icon: "diamond",
        url: "/points",
    },*/
    {
        title: "Overview",
        slug: "income",
        icon: "bar-chart",
        url: "/details",
    },
    /*{
        title: "Analytics",
        slug: "analytics",
        icon: "activity",
        url: "/customers/overview",
    },
    {
        title: "LiquidNFTs",
        icon: "promotion",
        url: "/promote",
    },*/
    ...(CASPER_SWITCH ? [{
        title: "Liquid Staking",
        reactIcon: <MdOutlineWaterDrop size={25}/>,
        url: "/liquid-staking",
    }] : []),
];

const Sidebar = ({ className, onClose, onExpand }) => {

    const { oldNftId, address } = useSelector(
        (state) => state.settings
    );

    const [visibleHelp, setVisibleHelp] = useState(false);
    const [visible, setVisible] = useState(false);
    const { isConnected } = useAccount();

    const isLargeDesktop = useMediaQuery("(max-width: 2000px)");
    const isMediumDesktop = useMediaQuery("(max-width: 1259px)");

    const handleExpand = () => {
        const isVisible = !visible;
        onExpand(isVisible);
        setVisible(isVisible);
    };

    useEffect(() => {
        onExpand(isLargeDesktop && visible);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLargeDesktop, visible]);

    // Always show all navigation items - chain restrictions are handled in the network dropdown
    const navigation = isConnected && POWER_USERS.includes(address)
        ? navigationFull
        : navigationLite;

    return (
        <>
            <div
                className={cn(
                    styles.sidebar,
                    className,
                    {
                        [styles.active]: isMediumDesktop && visible,
                        [styles.expand]: isLargeDesktop && visible
                    }
                )}
            >
                <button className={styles.close} onClick={onClose}>
                    <Icon name="close" size="24" />
                </button>
                <a className={styles.logo} href="https://wiselending.com/" rel="noreferrer" target="_blank">
                    <Image
                        className={styles.icon}
                        src="/images/blueLogo.svg"
                        srcDark="/images/blueLogo.svg"
                        alt="Core"
                    />
                    <Image
                        className={cn(styles.loger)}
                        src="/images/textLogo.svg"
                        srcDark="/images/textLogo.svg"
                        alt="Core"
                    />
                </a>
                <div className={styles.menu}>
                    {navigation.map((x, index) => {
                        const showNav = (x.title === "Archive" && _isNotEmptyNftId(oldNftId)) || x.title !== "Archive";
                        if (showNav) {
                            return (
                                x.url ? (
                                    <NavLink
                                        className={styles.item}
                                        activeClassName={styles.active}
                                        to={x.url}
                                        key={index}
                                        exact
                                        onClick={onClose}
                                    >
                                        {x.reactIcon ?? <Icon name={x.icon} size="24" />}
                                        {x.title}
                                    </NavLink>
                                ) : (
                                    <Dropdown
                                        className={styles.dropdown}
                                        visibleSidebar={visible}
                                        setValue={setVisible}
                                        key={index}
                                        item={x}
                                        onClose={onClose}
                                    />
                                )
                            );
                        } else {
                            return null;
                        }
                    })}
                </div>
                <button className={styles.toggle} onClick={() => setVisible(!visible)}>
                    <Icon name="arrow-right" size="24" />
                    <Icon name="close" size="24" />
                </button>
                <button className={styles.expandToggle} onClick={() => handleExpand()}>
                    <Icon name="arrow-right" size="24" />
                    <Icon name="arrow-left" size="24" />
                </button>
                <div className={styles.foot}>
                    <button className={styles.link} onClick={() => setVisibleHelp(true)}>
                        <Image
                            className={cn(styles.audit)}
                            src="/images/icons/security.svg"
                            srcDark="/images/icons/security.svg"
                            alt="audit"
                        />
                            Security Audits
                        <div className={styles.counter}>5</div>
                    </button>
                    <button className={styles.link} onClick={() => {
                        window.open("https://wisesoft.gitbook.io/wise/wiselending.com/wise-lending", "_blank", "noreferrer");
                    }}>
                        <Icon name="help" size="24" />
                            Wise Documentation
                        <div className={styles.counter}>1</div>
                    </button>
                </div>
                <div className={styles.foot}></div>
                {/*<Theme className={styles.theme} visibleSidebar={visible} />*/}
            </div>
            <Help
                visible={visibleHelp}
                setVisible={setVisibleHelp}
                onClose={onClose}
            />
            <div
                className={cn(styles.overlay, { [styles.active]: visible })}
                onClick={() => setVisible(false)}
            >
            </div>
        </>
    );
};

export default Sidebar;
